import {Component, inject, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {
  TenderPhaseControllerService,
  TenderPhaseDatesResponse,
  UpdateSubmissionDateRequestParams,
} from '@frontend/shared-api';
import {AppDatePipe} from '@frontend/shared';
import {firstValueFrom} from 'rxjs';
import {UpdateSubmissionDateButtonComponent} from '../update-submission-date-button/update-submission-date-button.component';
import {toLocalDateString} from '../../../../../utils/date-utils';

@Component({
  selector: 'app-timeframe-sub-phase-card',
  imports: [TranslocoPipe, AppDatePipe, UpdateSubmissionDateButtonComponent],
  templateUrl: './timeframe-sub-phase-card.component.html',
})
export class TimeframeSubPhaseCardComponent {
  private readonly tenderPhaseService = inject(TenderPhaseControllerService);

  readonly projectId = input.required<number>();
  readonly subPhase = input.required<TenderPhaseDatesResponse>();
  readonly shippingLabelKey = input.required<string>();
  readonly submissionLabelKey = input.required<string>();
  readonly shippingTestId = input.required<string>();
  readonly submissionTestId = input.required<string>();
  readonly editable = input.required<boolean>();

  readonly submissionDateUpdated = output<void>();

  protected async onUpdateSubmissionDate(submissionDate: Date): Promise<void> {
    const request: UpdateSubmissionDateRequestParams = {
      projectId: this.projectId(),
      updateSubmissionDateRequest: {submissionDate: toLocalDateString(submissionDate)},
    };

    await firstValueFrom(this.tenderPhaseService.updateSubmissionDate(request));
    this.submissionDateUpdated.emit();
  }
}
